import {StorageKey} from "@intuitionrobotics/thunderstorm/frontend";
import {QueryParam_Email} from "@app/ir-q-app-common/types/auth";


export const StorageKey_UserEmail: StorageKey<string> = new StorageKey<string>(`storage-${QueryParam_Email}`);

export const QueryParam_UnitId = "unitId";
export const QueryParam_ConfigId = "configId";
export const QueryParam_Product = 'product';
export const QueryParam_UserGroup = 'userGroup';
export const QueryParam_Version = 'version';
export const QueryParam_SomQR = 'somQR';
export const QueryParam_TabletQR = 'tabletQR';

export type ConfigId = string;
export type Product = string;

export const PINNED_PUSH_COMMANDS_IDS = 'pinnedPushCommandsIds';
export const RECENTLY_VISITED_UNITS_KEY = 'recentlyVisitedUnits';

export function getRecentlyVisitedUnits(): string[] {
    try {
        return JSON.parse(localStorage.getItem(RECENTLY_VISITED_UNITS_KEY) || '[]');
    } catch {
        return [];
    }
}

export function addRecentlyVisitedUnit(unitId: string): void {
    const recent = getRecentlyVisitedUnits().filter(id => id !== unitId);
    recent.unshift(unitId);
    localStorage.setItem(RECENTLY_VISITED_UNITS_KEY, JSON.stringify(recent.slice(0, 20)));
}

export function updateProperty<T extends object>(property: { [k: string]: T }, getKey: (element: T) => string, elements: T[]) {
    elements.reduce((carry, element) => {
        carry[getKey(element)] = element;
        return carry;
    }, property);
}

// Disenroll/return reasons grouped by reporting group, per the CS "Return Reasons"
// categorization guide v3.0 (ELLIQ-24047). The strings are the exact category labels
// shared across Ticket Attributes, Conversation Attributes, Support Tool and the
// Disenrollment Form — keep them verbatim so reporting stays aligned.
export type ReasonGroup = {
    group: string,
    reasons: string[]
}

export const ReasonsToDisenrollUnit: ReasonGroup[] = [
    {
        group: "Business Factors",
        reasons: [
            "Billing or Cancellation Issues",
            "Churned Account",
            "Cost or Value Concerns",
            "No Longer Qualified"
        ]
    },
    {
        group: "Product Experience",
        reasons: [
            "Communication Difficulties",
            "Device Performance & Responsiveness",
            "Product Limitations",
            "Too Talkative or Annoying"
        ]
    },
    {
        group: "Product Fit",
        reasons: [
            "Lack of Interest or Engagement",
            "Lifestyle Change or No Longer Needed",
            "Not a Good Fit",
            "Privacy Concerns"
        ]
    },
    {
        group: "User Circumstances",
        reasons: [
            "Health or Cognitive Limitations",
            "Transition to Higher Care",
            "Deceased"
        ]
    },
    {
        group: "Administrative",
        reasons: [
            "Account Information Correction",
            "Lost Unit | Damaged beyond recovery",
            "Lost Unit | Misplaced",
            "Lost Unit | Relocated without the unit",
            "Lost Unit | Stolen",
            "Lost Unit | User is unreachable after multiple attempts",
            "Lost Unit | V1 unit (Abandoned)",
            "Pilot, Demo, or Internal Unit",
            "Retroactive Return Processing",
            "Unit Was Never Installed (Cancelled)"
        ]
    },
    {
        group: "Unknown",
        reasons: [
            "Reason Unknown"
        ]
    }
]

export const ReasonsToCancelUnit = [
    "Order Canceled",
    "Network Environment Issues",
    "Lost"
]